module.exports = __webpack_public_path__ + "assets/066cd5a7a1852fb42637345cfd68691e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/bg/0.png
// module id = 359
// module chunks = 1